import * as React from 'react';
import { observer } from 'mobx-react';
import classNames from 'classnames';

import SelectorLabel from '@/UiBuilder/SelectorLabel/SelectorLabel';
import { Toggle } from '@/ui-kit/components/form/Toggle/Toggle';

import style from './ComponentSwitchCfgUIElement.module.css';
import { ComponentLookup } from '@/ui-kit/domain/ComponentLookup';
import { useCallback } from 'react';
import { IUICfgComponent, IUICfgComponentElementOptions } from '@canvas-logic/clp-api-types';
import styles from '@/UiBuilder/SelectorLabel/SelectorLabel.module.css';
import ThemeDefinition from '@/ui-kit/domain/ThemeDefinition';
import { Typography } from '@canvas-logic/clp-shared-ui';

interface IProps {
  lookup: ComponentLookup;
  icon?: React.ReactNode;
  title?: string;
  viewElement: IUICfgComponent;
}

const ComponentSwitchCfgUIElement: React.FC<IProps> = ({ lookup, icon, viewElement }) => {
  const uiSettings = viewElement.uiControl as IUICfgComponentElementOptions;
  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = lookup.values.find((option) => option.value === event.target.checked);

      if (value) {
        lookup.select(value.id);
      }
    },
    [lookup],
  );

  const showTitle = uiSettings.showTitle;
  const showDescription = uiSettings.showDescription;
  if (lookup.loading) {
    return null;
  }
  return (
    <fieldset className={classNames('cp-component-switch')}>
      {(showTitle || showDescription) && (
        <div>
          <div className={classNames('cp-component-switch__text-container')}>
            {icon && <img className={ThemeDefinition.selectorLabel.icon} src={icon} alt={lookup.texts.name || ''} />}
            {showTitle && <div className={'cp-component-switch__title'}>{lookup.texts.name}</div>}
            {showDescription && (
              <div className={'cp-component-switch__description paragraph-sm'}>{lookup.texts.description}</div>
            )}
          </div>
        </div>
      )}
      {uiSettings.showSwitcher && (
        <div className={'cp-component-switch__control'}>
          <Toggle
            checked={!!lookup.current.value}
            disabled={false === lookup.componentSchema?.optional}
            onChange={handleChange}
          />
        </div>
      )}
    </fieldset>
  );
};

export default observer(ComponentSwitchCfgUIElement);
